import { useEffect, useState } from 'react'
import { PAYS_PAR_DEFAUT, lirePaysDefaut, paysMemorise } from '../../../../../web-commun/connexion-whatsapp/api'
import type { ValeurTelephone } from '../../../../../web-commun/connexion-whatsapp/ChampTelephone'
import { supabase } from '../api/supabase'

/**
 * État d'un champ « Numéro WhatsApp » (`ChampTelephone`). Le pays de départ vient de la configuration
 * (`platform_config.pays_defaut`, via `lirePaysDefaut`) ou du dernier choix de cet appareil — jamais écrit en dur ici.
 * Tant que la configuration n'est pas lue, le champ part du pays de départ de la plateforme ; la lecture ne remplace
 * jamais un pays déjà choisi par la personne ni un numéro déjà saisi.
 */
export function useTelephone(initial = ''): [ValeurTelephone, (v: ValeurTelephone) => void] {
  const [valeur, setValeur] = useState<ValeurTelephone>({ texte: initial, iso: paysMemorise() ?? PAYS_PAR_DEFAUT })
  useEffect(() => {
    let vivant = true
    void lirePaysDefaut(supabase).then((p) => {
      if (vivant) setValeur((v) => (v.texte ? v : { ...v, iso: p.iso }))
    })
    return () => {
      vivant = false
    }
  }, [])
  return [valeur, setValeur]
}
